<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import EmptyLayout from '@/shared/layouts/EmptyLayout.vue';
import MainLayout from '@/shared/layouts/MainLayout.vue';

import { ru } from '@nuxt/ui/locale';

const route = useRoute();

// `main` unless the route asks for `empty` — a new screen gets the shell by
// default, which is the safe way round: forgetting the meta shows navigation
// where it was not planned, not a page with no way out.
const layoutName = computed((): 'main' | 'empty' => (route.meta.layout === 'empty' ? 'empty' : 'main'));
</script>

<template>
  <UApp
    :locale="ru"
    :toaster="{ progress: false }"
  >
    <MainLayout v-if="layoutName === 'main'" />
    <EmptyLayout v-else />
  </UApp>
</template>
